import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { concatMap } from 'rxjs/operators';
import { ConnectionEquipment, ConnectionEquipmentDetails, ConnectivityCatalogEntry, ConnectivityCatalogType, CONNECTIVITY_TYPE, ContentType, PING_STATUS, RESELLER_PAYMENT_STATUS } from 'src/app/domains/connectivity/models/connectivity.model';
import { ConnectivityService } from 'src/app/domains/connectivity/services/connectivity.service';

@Component({
  selector: 'gdp-company-connectivity-equipment-info-popup',
  templateUrl: './company-connectivity-equipment-info-popup.component.html',
  styleUrls: ['./company-connectivity-equipment-info-popup.component.scss']
})
export class CompanyConnectivityEquipmentInfoPopupComponent implements OnInit {
  public equipmentInfo: ConnectionEquipment;
  public equipmentInfoDetails: ConnectionEquipmentDetails;
  public equipmentCatalogEntryDetails: ConnectivityCatalogEntry;
  public loading: boolean = false;

  constructor(
    private activeModal: NgbActiveModal,
    private connectivityService: ConnectivityService
  ) {}

  ngOnInit(): void {
    this.getEquipmentDetails();
  }

  private getEquipmentDetails(): void {
    this.loading = true;
    this.connectivityService.getEquipmentDetails(this.equipmentInfo.id)
      .subscribe((res: ConnectionEquipmentDetails) => {
        this.equipmentInfoDetails = res;
        this.loading = false;
      }, () => {
        this.loading = false;
      });
  }

  public close(): void {
    this.activeModal.close();
  }
}